import classNames from "classnames";
import React from "react";
import { withDefault } from "../../utils/withDefault";

interface Props {
  duration?: number;
  delay?: number;
  className?: string;
  style?: React.CSSProperties;
  asChild?: boolean;
  children: React.ReactNode;
}

const AppSlideFadeIn = (props: Props) => {
  const duration = withDefault(props.duration, 500);
  const delay = withDefault(props.delay, 0);
  const asChild = withDefault(props.asChild, false);

  const styles: React.CSSProperties = {
    animationDuration: duration + "ms",
    animationDelay: delay + "ms",
    animationFillMode: "backwards",
  };

  if (asChild) {
    if (React.Children.count(props.children) > 1) {
      throw new Error("AppSlideFadeIn asChild can only have one child");
    }

    const child = React.Children.only(props.children);
    const element = React.isValidElement(child) ? child : null;

    if (element === null) {
      throw new Error("AppSlideFadeIn asChild must have a valid child element");
    }

    // clone and add props to the child
    return React.cloneElement(element, {
      className: classNames("AppSlideFadeIn", props.className, element.props.className),
      style: {
        ...styles,
        ...element.props.style,
      },
    });
  }

  return (
    <div
      className={classNames("AppSlideFadeIn", props.className)}
      style={{
        ...styles,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};

export default AppSlideFadeIn;
